const ExploreCardChips = () => {
  return (
    <div>
      {" "}
      <div>
        <div className="flex gap-1  ">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="19.304"
            height="17.59"
            viewBox="0 0 22.304 19.59"
          >
            <g
              id="Group_411898"
              data-name="Group 411898"
              transform="translate(0 0)"
            >
              <g
                id="Group_411897"
                data-name="Group 411897"
                transform="translate(0.348 0.346)"
              >
                <path
                  id="Path_266958"
                  data-name="Path 266958"
                  d="M29.607,118.988v4.573a1.356,1.356,0,0,1-.5,1.052c-1.08.879-4.053,2.678-10.3,2.678s-9.223-1.8-10.3-2.678a1.356,1.356,0,0,1-.5-1.052v-4.573a1.356,1.356,0,0,1,1.356-1.356H28.251A1.356,1.356,0,0,1,29.607,118.988Z"
                  transform="translate(-8 -114.21)"
                  fill="#9c8f9a"
                />
                <path
                  id="Path_266959"
                  data-name="Path 266959"
                  d="M29.607,118.988v4.573a1.356,1.356,0,0,1-.5,1.052c-1.08.879-4.053,2.678-10.3,2.678s-9.223-1.8-10.3-2.678a1.356,1.356,0,0,1-.5-1.052v-4.573a1.356,1.356,0,0,1,1.356-1.356H28.251A1.356,1.356,0,0,1,29.607,118.988Z"
                  transform="translate(-8 -114.21)"
                  fill="#9c8f9a"
                />
                <path
                  id="Path_266960"
                  data-name="Path 266960"
                  d="M29.607,118.988v4.573a1.356,1.356,0,0,1-.5,1.052c-1.08.879-4.053,2.678-10.3,2.678s-9.223-1.8-10.3-2.678a1.356,1.356,0,0,1-.5-1.052v-4.573a1.356,1.356,0,0,1,1.356-1.356H28.251A1.356,1.356,0,0,1,29.607,118.988Z"
                  transform="translate(-8 -114.21)"
                  fill="#407093"
                />
                <path
                  id="Path_266961"
                  data-name="Path 266961"
                  d="M29.106,236.783c-1.08.879-4.053,2.678-10.3,2.678s-9.223-1.8-10.3-2.678a1.356,1.356,0,0,1-.5-1.052v.784a1.356,1.356,0,0,0,.5,1.052c1.08.879,4.053,2.678,10.3,2.678s9.223-1.8,10.3-2.678a1.356,1.356,0,0,0,.5-1.052v-.784A1.356,1.356,0,0,1,29.106,236.783Z"
                  transform="translate(-8 -227.165)"
                  fill="#365e7d"
                />
                <path
                  id="Path_266962"
                  data-name="Path 266962"
                  d="M31.077,281.595c-6.14,0-9.118-1.736-10.244-2.631v7.093a1.356,1.356,0,0,0,1.356,1.356H39.965a1.356,1.356,0,0,0,1.356-1.356v-7.093C40.195,279.858,37.217,281.595,31.077,281.595Z"
                  transform="translate(-20.274 -268.514)"
                  fill="#365e7d"
                />
                <path
                  id="Path_266963"
                  data-name="Path 266963"
                  d="M20.833,278.964v.784c1.127.895,4.1,2.631,10.244,2.631s9.118-1.736,10.244-2.631v-.784c-1.127.895-4.1,2.631-10.244,2.631S21.96,279.858,20.833,278.964Z"
                  transform="translate(-20.274 -268.514)"
                  fill="#2b4d66"
                />
                <path
                  id="Path_266964"
                  data-name="Path 266964"
                  d="M228.107,306.66a1.27,1.27,0,0,1-1.27-1.27v-1.554a.452.452,0,0,1,.452-.452h1.636a.452.452,0,0,1,.452.452v1.554A1.27,1.27,0,0,1,228.107,306.66Z"
                  transform="translate(-217.304 -291.87)"
                  fill="#ffe27a"
                />
                <path
                  id="Path_266965"
                  data-name="Path 266965"
                  d="M228.107,332.71a1.27,1.27,0,0,1-1.27-1.27v.784a1.27,1.27,0,0,0,2.541,0v-.784A1.27,1.27,0,0,1,228.107,332.71Z"
                  transform="translate(-217.304 -318.704)"
                  fill="#f9cf58"
                />
                <path
                  id="Path_266966"
                  data-name="Path 266966"
                  d="M172.687,42.507v-1.5a5.355,5.355,0,0,1,4.542,0v1.5h1.42v-1.9a.71.71,0,0,0-.28-.565,4.254,4.254,0,0,0-.938-.5,6.908,6.908,0,0,0-4.946,0,4.251,4.251,0,0,0-.938.5.71.71,0,0,0-.28.565v1.9h1.42Z"
                  transform="translate(-164.155 -39.085)"
                  fill="#e8834d"
                />
                <g
                  id="Group_411896"
                  data-name="Group 411896"
                  transform="translate(7.112 2.638)"
                >
                  <path
                    id="Path_266967"
                    data-name="Path 266967"
                    d="M171.267,99.633h1.42v.784h-1.42Z"
                    transform="translate(-171.267 -99.633)"
                    fill="#d66e41"
                  />
                  <path
                    id="Path_266968"
                    data-name="Path 266968"
                    d="M308.124,99.633h1.42v.784h-1.42Z"
                    transform="translate(-302.162 -99.633)"
                    fill="#d66e41"
                  />
                </g>
              </g>
              <path
                id="Path_266969"
                data-name="Path 266969"
                d="M20.618,34.574h-5.44V33a1.045,1.045,0,0,0-.409-.826,4.545,4.545,0,0,0-1.017-.545,6.4,6.4,0,0,0-.808-.262.327.327,0,1,0-.161.635,5.749,5.749,0,0,1,.725.235,3.974,3.974,0,0,1,.864.458.386.386,0,0,1,.151.305v1.575h-.768V33.4a.327.327,0,0,0-.179-.292,5.375,5.375,0,0,0-2.424-.542,5.374,5.374,0,0,0-2.424.542.327.327,0,0,0-.179.292v1.172H7.781V33a.386.386,0,0,1,.151-.306,3.971,3.971,0,0,1,.864-.458,6.377,6.377,0,0,1,2.356-.435c.139,0,.28,0,.419.013a.327.327,0,1,0,.04-.654c-.152-.009-.307-.014-.459-.014a7.038,7.038,0,0,0-2.6.482,4.545,4.545,0,0,0-1.017.545A1.045,1.045,0,0,0,7.126,33v1.575H1.686A1.688,1.688,0,0,0,0,36.26v4.582A1.679,1.679,0,0,0,.56,42.1V49.05a1.688,1.688,0,0,0,1.686,1.686H15.18a.327.327,0,1,0,0-.655H2.246A1.033,1.033,0,0,1,1.215,49.05V42.583A10.952,10.952,0,0,0,3.181,43.6a.327.327,0,1,0,.244-.608,9.215,9.215,0,0,1-2.39-1.348,1.028,1.028,0,0,1-.38-.8V36.26a1.033,1.033,0,0,1,1.031-1.031H20.618a1.033,1.033,0,0,1,1.031,1.031v4.582a1.028,1.028,0,0,1-.38.8,9.61,9.61,0,0,1-2.784,1.5,19.9,19.9,0,0,1-5.733,1.069v-.747a.781.781,0,0,0-.78-.78h-1.64a.781.781,0,0,0-.78.78v.748a21.331,21.331,0,0,1-4.778-.758.327.327,0,0,0-.182.629,22.023,22.023,0,0,0,4.96.784v.154a1.6,1.6,0,0,0,3.2,0v-.154c4.427-.231,6.989-1.384,8.337-2.281V49.05a1.033,1.033,0,0,1-1.031,1.031H16.49a.327.327,0,0,0,0,.655h3.568a1.688,1.688,0,0,0,1.686-1.686V42.1a1.679,1.679,0,0,0,.56-1.255V36.26a1.688,1.688,0,0,0-1.686-1.686ZM9.2,33.61a5.109,5.109,0,0,1,3.9,0v.965H9.2V33.61ZM12.1,45.019a.945.945,0,0,1-1.891,0V43.462a.126.126,0,0,1,.126-.126h1.64a.126.126,0,0,1,.126.126Z"
                transform="translate(0 -31.146)"
              />
            </g>
          </svg>
          <h5 className="text-[12px]">Experience</h5>
        </div>
        <h4>10 Years</h4>
      </div>
    </div>
  );
};

export default ExploreCardChips;
